import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface Holiday {
  _id: string;
  org: string;
  title: string;
  date: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export type HolidaysPayload = {
  title: string;
  dates: string[];
};

export type HolidaysResponse = {
  success: boolean;
  message: string;
  data: Holiday;
};

const addHoliday = async (
  payload: HolidaysPayload
): Promise<HolidaysResponse> => {
  const { data } = await customAxios.post<HolidaysResponse>(
    "/holidays",
    payload
  );
  return data;
};

export const useAddHolidays = () => {
  const queryClient = useQueryClient();

  return useMutation<HolidaysResponse, AxiosError, HolidaysPayload>({
    mutationFn: addHoliday,
    onSuccess: async (data) => {
      showNotification({
        title: "Success",
        message: data.message,
        color: "green",
      });

      await queryClient.invalidateQueries(["holidays"]);
    },
    onError: (error) =>
      showNotification({
        title: "Error",
        message:
          (error.response?.data as { message?: string })?.message ??
          "Failed to add holiday",
        color: "red",
      }),
  });
};
